import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// User Model
import VuexORM from '@vuex-orm/core';
import Project from "./Project";
import User from "./User";
import Phase from "./Phase";

var EntrySuggestion = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(EntrySuggestion, _VuexORM$Model);

  var _super = _createSuper(EntrySuggestion);

  function EntrySuggestion() {
    _classCallCheck(this, EntrySuggestion);

    return _super.apply(this, arguments);
  }

  _createClass(EntrySuggestion, [{
    key: "$delete",
    value: function $delete() {
      var _this = this;

      if (this.type === 'recurrent') {
        // TODO add dialog to confirm deletion method
        return EntrySuggestion.api().put('/recurrent-suggestions/' + this.repeatable_suggestion_id, {
          exception: this.entry_date
        }).then(function () {
          EntrySuggestion.delete(_this.entry_suggestion_id);
        });
      } else {
        return EntrySuggestion.api().delete('/entry-suggestions/' + this.entry_suggestion_id, {
          delete: this.entry_suggestion_id
        });
      }
    }
  }, {
    key: "$ignore",
    value: function $ignore() {
      var _this2 = this;

      if (this.type === 'recurrent') {
        return EntrySuggestion.api().put('/recurrent-suggestions/' + this.repeatable_suggestion_id, {
          ignore: true
        }).then(function () {
          EntrySuggestion.delete(_this2.entry_suggestion_id);
        });
      } else {
        return this.$delete();
      }
    }
  }], [{
    key: "fields",
    value: // This is the name used as module name of the Vuex Store.
    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    function fields() {
      return {
        entry_suggestion_id: this.attr(null),
        created_datetime: this.attr(null),
        user_id: this.attr(null),
        user_name: this.attr(null),
        user: this.belongsTo(User, 'user_id', 'user_id'),
        project_id: this.attr(null),
        project_name: this.attr(null),
        project: this.belongsTo(Project, 'project_id', 'project_id'),
        client_id: this.attr(-1),
        task_id: this.attr(null),
        task_name: this.attr(null),
        phase: this.belongsTo(Phase, 'task_id', 'task_id'),
        notes: this.attr(null),
        date: this.attr(null),
        entry_date: this.attr(null),
        source: this.attr(null),
        source_text: this.attr(null),
        source_url: this.attr(null),
        source_id: this.attr(null),
        source_data: this.attr(null),
        entry_minutes: this.attr(null),
        original_duration: this.attr(null),
        accuracy: this.attr(null),
        aggregable: this.attr(null),
        deleted: this.attr(null),
        unique_hash: this.attr(null),
        accepted: this.attr(null),
        project_color: this.attr(null),
        account_id: this.attr(null),
        platform: this.attr(null),
        platform_details: this.attr(null),
        type: this.attr(null),
        repeatable_suggestion_id: this.attr(null),
        origin_date: this.attr(null),
        start_time: this.attr(null),
        time_from: this.attr(null),
        time_to: this.attr(null)
      };
    }
  }]);

  return EntrySuggestion;
}(VuexORM.Model);

_defineProperty(EntrySuggestion, "entity", 'entry-suggestions');

_defineProperty(EntrySuggestion, "primaryKey", 'entry_suggestion_id');

_defineProperty(EntrySuggestion, "state", {
  pending: false,
  lastSync: null
});

export { EntrySuggestion as default };